module.exports = __webpack_public_path__ + "img/img4.749d9637.jpg";